import React from 'react';

import { DateTimeValue, formatMomentDate } from 'utils/formatters/timezone';

import { JSONSchemaValue } from 'utils/api/modules/incidents/incidents.types';

import { Text } from './styles';

const formatCell = (value: unknown): string => formatMomentDate(value as DateTimeValue);

export const momentDateRenderer = ({ value }: { value: JSONSchemaValue }): React.ReactNode => (
  <Text>{(value?.value && formatCell(value.value)) || 'N/A'}</Text>
);

// MUI hands valueFormatter the valueGetter's output, which for a custom column wraps the raw value once
export const momentDateFormatter = (item: { value: unknown } | null): string => formatCell(item?.value);
